import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Form, message } from "antd";
import { LockOutlined, UserOutlined, EyeOutlined, EyeInvisibleOutlined, AlertOutlined, } from "@ant-design/icons";
import { encodeRSA } from "@/utils/rsa";
import { useNavigate } from "react-router-dom";
import { loginApi } from "@/api/loginApi";
import { setToken } from "@/utils/auth";
import { useCompanyStore } from "@/stores/useCompanyStore";
const LoginPage = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [isCapsLockOn, setIsCapsLockOn] = useState(false);
    const navigate = useNavigate();
    // 监听 CapsLock 状态
    const handleKeyDown = (e) => {
        setIsCapsLockOn(e.getModifierState("CapsLock"));
    };
    // 登录核心逻辑
    const handleLogin = async (values) => {
        setLoading(true);
        setError(null);
        try {
            // RSA加密登录参数
            const loginParams = {
                username: encodeRSA(values.username),
                password: encodeRSA(values.password),
            };
            // 执行登录请求
            const response = await loginApi.login(loginParams);
            // 存储Token
            const { token } = response;
            setToken(token);
            // 记住用户名
            if (values.remember) {
                localStorage.setItem("rememberedUser", JSON.stringify({ username: values.username }));
            }
            else {
                localStorage.removeItem("rememberedUser");
            }
            // 登录成功跳转
            message.success("登录成功，正在跳转...");
            useCompanyStore.getState().resetCompany(); // 登录成功后重置公司信息
            setTimeout(() => {
                navigate("/common");
            }, 1000);
        }
        catch (err) {
            // 错误处理
            console.error("Login error:", err);
            const errorMsg = err?.message || "登录失败，请检查账号密码或网络";
            setError(errorMsg);
            message.error(errorMsg);
        }
        finally {
            setLoading(false);
        }
    };
    // 【新增】校验失败的处理逻辑
    const handleLoginFailed = (errorInfo) => {
        message.warning("请完善登录信息");
    };
    // 密码可见性切换
    const handlePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    // 初始化填充记住的用户名
    useEffect(() => {
        const rememberedUserStr = localStorage.getItem("rememberedUser");
        if (rememberedUserStr) {
            try {
                const rememberedUser = JSON.parse(rememberedUserStr);
                if (typeof rememberedUser?.username === "string") {
                    form.setFieldsValue({
                        username: rememberedUser.username,
                        remember: true,
                    });
                }
            }
            catch (parseErr) {
                console.error("解析记住的用户信息失败:", parseErr);
                localStorage.removeItem("rememberedUser");
            }
        }
    }, [form]);
    return (_jsx("div", { style: { width: "100vw", height: "100vh", overflow: "hidden" }, children: _jsxs("div", { className: "login-page-container", children: [_jsxs("div", { className: "login-content", children: [_jsx("div", { className: "login-title" }), _jsxs("div", { className: "login-form-wrapper", children: [error && (_jsxs("div", { className: "login-error-alert", children: [_jsx(AlertOutlined, { style: { marginRight: 8 } }), error] })), _jsxs(Form, { form: form, name: "loginForm", initialValues: { username: "", password: "", remember: true }, onFinish: handleLogin, className: "login-form", children: [_jsx(Form.Item, { name: "username", noStyle: true, children: _jsxs("div", { className: "tech-input-group", children: [_jsxs("div", { className: "tech-input-prefix", children: [_jsx(UserOutlined, {}), _jsx("span", { children: "\u8D26\u53F7" })] }), _jsx("input", { className: "tech-input", placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u540D" })] }) }), _jsx(Form.Item, { name: "password", noStyle: true, children: _jsxs("div", { className: "tech-input-group", children: [_jsxs("div", { className: "tech-input-prefix", children: [_jsx(LockOutlined, {}), _jsx("span", { children: "\u5BC6\u7801" })] }), _jsx("input", { className: "tech-input", placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801", type: showPassword ? "text" : "password", onKeyDown: handleKeyDown, onKeyUp: handleKeyDown }), _jsx("span", { className: "password-toggle-icon", onClick: handlePasswordVisibility, children: showPassword ? _jsx(EyeOutlined, {}) : _jsx(EyeInvisibleOutlined, {}) })] }) }), isCapsLockOn && (_jsxs("div", { className: "caps-lock-warning", children: [_jsx(AlertOutlined, {}), _jsx("span", { children: "Caps Lock\u5DF2\u5F00\u542F\uFF0C\u53EF\u80FD\u5BFC\u81F4\u8F93\u5165\u9519\u8BEF" })] })), _jsx(Form.Item, { name: "remember", valuePropName: "checked", noStyle: true, children: _jsx("input", { type: "checkbox", style: { display: "none" } }) }), _jsx(Form.Item, { noStyle: true, children: _jsxs("button", { type: "submit", className: "tech-login-btn", disabled: loading, children: [_jsx("div", { className: "btn-arrow-part" }), _jsx("div", { className: "btn-text-part", children: loading ? "登录中..." : "登录" })] }) })] })] })] }), _jsx("div", { className: "login-copyright", children: "\u9655\u897F\u5B89\u8F69\u667A\u80FD\u79D1\u6280\u6709\u9650\u516C\u53F8 Copyright \u00A92025 All Rights Reserved." })] }) }));
};
export default LoginPage;
